import { ColoredCircle, FlexColumn, LabeledData } from '@gorila-shared-ui/components';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { VehicleCore } from '../../types/vehicle';
import { isBrand, isSubBrand } from '../../utils/assets';

type Props = Readonly<{
  vehicle?: VehicleCore;
  labelWidth?: string;
  ignoreSpacing?: boolean;
}>;

function VehicleData({ vehicle, labelWidth = '100px', ignoreSpacing = false }: Props) {
  const { theme, classes, css } = useStyles();

  return (
    <FlexColumn gap={theme.sizing.scale200}>
      <LabelMedium className={classes.dataHeaderClass}>Datos del vehículo</LabelMedium>
      <FlexColumn gap={ignoreSpacing ? 0 : theme.sizing.scale200}>
        <LabeledData label="Placa:" content={vehicle?.licensePlate} labelWidth={labelWidth} inline={false} />
        <LabeledData label="Tipo:" content={vehicle?.vehicleType} labelWidth={labelWidth} inline={false} />
        <LabeledData
          label="Marca:"
          content={isBrand(vehicle?.brand) ? vehicle!.brand.name : (vehicle?.brand ?? '-')}
          labelWidth={labelWidth}
          inline={false}
        />
        <LabeledData
          label="Submarca:"
          content={isSubBrand(vehicle?.subBrand) ? vehicle!.subBrand.name : (vehicle?.subBrand ?? '-')}
          labelWidth={labelWidth}
          inline={false}
        />
        <LabeledData
          label="Modelo:"
          content={vehicle?.year?.toString() ?? '-'}
          labelWidth={labelWidth}
          inline={false}
        />
        <LabeledData
          label="Color:"
          verticalAlign="center"
          content={
            <ParagraphSmall
              color={theme.colors.contentSecondary}
              margin={0}
              className={`${classes.horizontalFlex} ${classes.centeredStart} ${css({
                gap: theme.sizing.scale200,
              })}`}
            >
              {vehicle?.color ? <ColoredCircle color={vehicle.color} /> : '-'}
            </ParagraphSmall>
          }
          labelWidth={labelWidth}
        />
        <LabeledData label="No. Serie:" content={vehicle?.vin} labelWidth={labelWidth} inline={false} />
      </FlexColumn>
    </FlexColumn>
  );
}

export default memo(VehicleData);
